import { createStore } from 'vuex'
import Cookies from 'js-cookie'
import * as api from '@/api'

export default createStore({
  state: {
    // 用户信息
    userInfo: null,
    token: Cookies.get('admin_token') || '',
    
    // 系统状态
    sidebarCollapsed: false,
    theme: localStorage.getItem('theme') || 'light',
    
    // 权限
    permissions: [],
    
    // 系统配置
    systemConfig: {}
  },
  
  getters: {
    // 是否已登录
    isLoggedIn: state => !!state.token,
    
    // 获取token
    token: state => state.token,
    
    // 获取用户信息
    userInfo: state => state.userInfo,
    
    // 侧边栏状态
    sidebarCollapsed: state => state.sidebarCollapsed,
    
    // 主题
    theme: state => state.theme,
    
    // 权限检查
    hasPermission: state => permission => {
      return state.permissions.includes(permission)
    }
  },
  
  mutations: {
    // 设置token
    SET_TOKEN(state, token) {
      state.token = token
      if (token) {
        Cookies.set('admin_token', token, { expires: 7 })
      } else {
        Cookies.remove('admin_token')
      }
    },
    
    // 设置用户信息
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
      // 同时保存到localStorage
      if (userInfo) {
        localStorage.setItem('admin_user_info', JSON.stringify(userInfo))
      } else {
        localStorage.removeItem('admin_user_info')
      }
    },
    
    // 切换侧边栏
    TOGGLE_SIDEBAR(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed
    },
    
    // 设置主题
    SET_THEME(state, theme) {
      state.theme = theme
      localStorage.setItem('theme', theme)
      document.documentElement.setAttribute('data-theme', theme)
    },
    
    // 设置权限
    SET_PERMISSIONS(state, permissions) {
      state.permissions = permissions
    },
    
    // 设置系统配置
    SET_SYSTEM_CONFIG(state, config) {
      state.systemConfig = config
    },
    
    // 清除用户数据
    CLEAR_USER_DATA(state) {
      state.token = ''
      state.userInfo = null
      state.permissions = []
      Cookies.remove('admin_token')
      localStorage.removeItem('admin_user_info')
    },

    // 恢复用户数据
    RESTORE_USER_DATA(state) {
      const token = Cookies.get('admin_token')
      const userInfo = localStorage.getItem('admin_user_info')

      if (token) {
        state.token = token
      }

      if (userInfo) {
        try {
          state.userInfo = JSON.parse(userInfo)
        } catch (error) {
          console.error('解析用户信息失败:', error)
          localStorage.removeItem('admin_user_info')
        }
      }
    }
  },
  
  actions: {
    // 登录
    async login({ commit }, { username, password }) {
      try {
        const response = await api.login({ username, password })

        if (response.code === 1) {
          const { token, adminInfo } = response.data

          commit('SET_TOKEN', token)
          commit('SET_USER_INFO', adminInfo)

          return { success: true }
        } else {
          return { success: false, message: response.msg }
        }
      } catch (error) {
        console.error('登录失败:', error)
        return { success: false, message: error.message || '登录失败，请稍后重试' }
      }
    },
    
    // 退出登录
    async logout({ commit }) {
      try {
        await api.logout()
      } catch (error) {
        console.error('退出登录失败:', error)
      } finally {
        commit('CLEAR_USER_DATA')
      }
    },
    
    // 获取用户信息
    async getUserInfo({ commit, state }) {
      try {
        if (!state.token) return
        
        const response = await api.getAdminProfile()
        
        if (response.code === 1) {
          commit('SET_USER_INFO', response.data)
          return response.data
        }
      } catch (error) {
        console.error('获取用户信息失败:', error)
        commit('CLEAR_USER_DATA')
      }
    },
    
    // 切换主题
    toggleTheme({ commit, state }) {
      const newTheme = state.theme === 'light' ? 'dark' : 'light'
      commit('SET_THEME', newTheme)
    },

    // 恢复登录状态
    async restoreAuth({ commit, dispatch }) {
      commit('RESTORE_USER_DATA')

      // 如果有token，尝试获取最新的用户信息
      const token = Cookies.get('admin_token')
      if (token) {
        try {
          await dispatch('getUserInfo')
        } catch (error) {
          console.error('恢复用户信息失败:', error)
          // 如果获取用户信息失败，清除所有数据
          commit('CLEAR_USER_DATA')
        }
      }
    }
  },
  
  modules: {
    // 可以在这里添加模块
  }
})
